import { Box, ButtonBase, Stack, styled, Typography, useTheme } from "@mui/material";
import { LocalizationContext } from "../../localization/index.js";
import { NumberOfPlayersChip, makeCurrencyFormatter, price } from "../../product/index.js";
import { useMediaQuery } from "../../utilities/index.js";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import Grid from "@mui/material/Unstable_Grid2";
import Image from "next/image";
import Link from "next/link";
import React from "react";
const StyledLink = styled(Link)({
    textDecoration: "none",
    "&: hover": {
        opacity: 1,
    },
});
export const ViewGrid = ({ products = [], showPrice = true }) => {
    const { t } = useTranslation("c-common");
    const theme = useTheme();
    const router = useRouter();
    const isTouchDevice = useMediaQuery("(hover: none)");
    const { market } = React.useContext(LocalizationContext);
    const PADDING = isTouchDevice ? 0 : { sm: 2, lg: 3 };
    const BORDER_RADIUS = "16px";
    const IMAGE_STYLES = {
        "&:hover": { a: { opacity: 1 } },
        a: { "&:hover": { opacity: 1 }, display: "flex" },
        borderRadius: "6px",
        boxShadow: "product",
        display: "flex",
    };
    const negate = (p) => typeof p === "number" ? p * -1 : { sm: p.sm * -1, lg: p.lg * -1 };
    const categoryPath = t("slug-print");
    return (React.createElement(Box, { component: "ul", sx: {
            display: "grid",
            gridTemplateColumns: {
                sm: "1fr 1fr",
                md: isTouchDevice ? "1fr 1fr 1fr" : "1fr 1fr",
                lg: "1fr 1fr 1fr",
            },
            listStyleType: "none",
            mx: negate(PADDING),
            my: negate(PADDING),
            padding: 0,
            rowGap: { sm: theme.spacing(6), md: theme.spacing(4) },
            columnGap: { xs: isTouchDevice ? theme.spacing(1.5) : 0 },
        } }, products.map((product) => {
        const { amount, currency } = price({ product, market });
        const formatCurrency = makeCurrencyFormatter({ currency });
        return (React.createElement(StyledLink, { key: `product-grid-${product.slug}`, href: `/${categoryPath}/${encodeURIComponent(product.slug)}` },
            React.createElement(ButtonBase, { component: "li", onClick: () => router.push(`/${categoryPath}/${encodeURIComponent(product.slug)}`), sx: {
                    "&:hover": isTouchDevice ? {} : { backgroundColor: "white", cursor: "pointer" },
                    backgroundColor: "transparent",
                    borderRadius: BORDER_RADIUS,
                    p: PADDING,
                    transition: theme.transitions.create("background-color"),
                } },
                React.createElement(Grid, { container: true, spacing: 3, xs: 12, key: `product-grid-${product.slug}` },
                    React.createElement(Grid, { xs: 5 },
                        React.createElement(Box, { className: "image-container", style: { backgroundColor: product.colors.primary ?? "#fff" }, sx: IMAGE_STYLES },
                            React.createElement(Image, { ...product.coverImage, alt: product.title, placeholder: "blur", style: { width: "100%", maxWidth: "100%", height: "auto" }, title: product.title }))),
                    React.createElement(Grid, { xs: 7 },
                        React.createElement(Stack, { direction: "column", justifyContent: "space-between", sx: { height: "100%" } },
                            React.createElement(Typography, { component: "div", className: "hyphenate", variant: "body2", dangerouslySetInnerHTML: { __html: product.tagline } }),
                            React.createElement(Stack, { direction: "column", alignItems: "flex-start", sx: { mt: { xs: 2.25, lg: 4 } } },
                                React.createElement(NumberOfPlayersChip, { product: product }),
                                showPrice && (React.createElement(Stack, { alignItems: "baseline", direction: "row", spacing: 1, sx: { mt: 0.75 } },
                                    React.createElement(Typography, { variant: "body2", sx: { pt: 0, pb: 0 } }, formatCurrency(amount)),
                                    React.createElement(Typography, { variant: "caption" }, t("inclusive-vat", "inkl. MwSt.")))))))))));
    })));
};
//# sourceMappingURL=view-grid.js.map